<template>
<div class="chapter">
<div class="inner_page">
<div id="epub4231-8.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="CN para-style-override-4" id="toc_marker-9" xml:lang="en-GB"><span class="char-style-override-6">PART ONE</span></p>
<p class="PT"><span class="char-style-override-5">CROSSING THE BRIDGE</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epub4231-8.vue?e3f73564